import { Tabs } from "antd";
import React, { useEffect, useState } from "react";
import ProjectsData from "../Components/ProjectTab/ProjectsData";
import SubmittedIdeas from "../Components/ProjectTab/SubmittedIdeas";
import UserProjectsData from "../Components/ProjectTab/UserProjectsData";
import AwsAxios from "../utils/AwsAxios";
import { getProjectsData } from "../slices/courseraSlice";
import { useDispatch, useSelector } from "react-redux";

const Projects = () => {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  // const { items: data } = allCampaignData;
  let [projectsData, setProjectsData] = useState([]);
  let [Imageloading, setImageLoading] = useState([]);
  console.log(projectsData, "project-dataaaaaa-li");
  const dispatch = useDispatch();
  const userProjectData = useSelector((state) => state.coursera.projectData);

  // console.log(data, "dataaaaafromcampp")

  // projectsData = projectsData.items.map((properties) => properties);

  // const fetchImageApi = async (image) => {
  //   try {
  //     const parts = image?.split("/resources/");
  //     const imageId = parts[1];
  //     console.log(imageId, "Response fetch imagessss");
  //     const response = await AwsAxios.get(
  //       `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/image/${imageId}`
  //     );

  //     console.log(response.data, "Response fetch imagessss");
  //     return `data:image/jpeg;base64,${response.data}`;
  //   } catch (error) {
  //     console.error("Error fetching image:", error);
  //     return null;
  //   }
  // };

  const imageCache = {};

  const fetchImageApi = async (image) => {
    const parts = image?.split("/resources/");
    const imageId = parts[1];
    if (imageCache[imageId]) {
      return imageCache[imageId];
    }
    try {
      const response = await AwsAxios.get(
        `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/image/${imageId}`
      );
      const imageData = `data:image/jpeg;base64,${response.data}`;
      imageCache[imageId] = imageData;
      return imageData;
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setImageLoading(true);
        dispatch(getProjectsData());
        const response = await AwsAxios.get(
          `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/portfolio/Portfolio--Campaigns-For-Back-End-Import`
        );
        console.log(response, "response From api all campaigns");
        const projects = response.data.data.items;
        // const titles = projects.map(project => project.properties.find(property => property.type === 'SIMPLE' && property.id === 'eae8f263-461c-4940-9b5c-9ebcea4c60b0').value);

        // // Define the desired order of titles
        const desiredOrder = [
          "The M3 Platform: A Global Community for Talent",
          "Community Creativity",
          "Creathon for Schools",
          "Creathon for Workplace",
          "Creathon for Homes",
        ];

        // // Custom sorting function
        // const customSort = (a, b) => {
        //   return desiredOrder.indexOf(a) - desiredOrder.indexOf(b);
        // };

        // // Sort the titles array using the custom sorting function
        // titles.sort(customSort);
        // const filteredTitles = titles.filter(title => [
        //   'The M3 Platform: A Global Community for Talent',
        //   'Community Creativity',
        //   'Creathon for Schools',
        //   'Creathon for Workplace',
        //   'Creathon for Homes'
        // ].includes(title));

        // const sortedProjects = projects.filter((project) =>
        //   filteredTitles.includes(
        //     project.properties.find(
        //       (property) =>
        //         property.type === "SIMPLE" &&
        //         property.id === "eae8f263-461c-4940-9b5c-9ebcea4c60b0"
        //     ).value
        //   )
        // );

        const sortedProjects = projects.sort((a, b) => {
          const titleA = a.properties.find(
            (property) =>
              property.type === "SIMPLE" &&
              property.id === "eae8f263-461c-4940-9b5c-9ebcea4c60b0"
          ).value;
          const titleB = b.properties.find(
            (property) =>
              property.type === "SIMPLE" &&
              property.id === "eae8f263-461c-4940-9b5c-9ebcea4c60b0"
          ).value;
          return desiredOrder.indexOf(titleA) - desiredOrder.indexOf(titleB);
        });

        console.log({ sortedProjects });

        const filteredProjects = sortedProjects.filter((project) =>
          desiredOrder.includes(
            project.properties.find(
              (property) =>
                property.type === "SIMPLE" &&
                property.id === "eae8f263-461c-4940-9b5c-9ebcea4c60b0"
            ).value
          )
        );

        console.log(filteredProjects, "titlessssssssssssssss");
        setProjectsData(sortedProjects);
        setLoading(false);
        //Changes made here
        const updatedProjects = await Promise.all(
          sortedProjects.map(async (project) => {
            const updatedProperties = await Promise.all(
              project.properties.map(async (property) => {
                if (
                  property.type === "RESOURCES" &&
                  property.resources?.length > 0
                ) {
                  const image = await fetchImageApi(
                    property.resources[0].value
                  );
                  return {
                    ...property,
                    resources: image ? [image] : [],
                  };
                }
                return property;
              })
            );

            return {
              ...project,
              properties: updatedProperties,
            };
          })
        );

        if (updatedProjects.length > 0) {
          console.log(updatedProjects, "updatedProjects with images");
          setProjectsData(updatedProjects);
          setImageLoading(false);
        }
      } catch (error) {
        setImageLoading(false);
        console.error("Error fetching project data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // const extractProjectData = useCallback(async (projectsData) => {
  //   const projects = await Promise.all(
  //     projectsData.items.map(async (item) => {
  //       const extractedProperties = await Promise.all(
  //         item.properties.map(async (property) => {
  //           if (property.type === "RESOURCES" && property?.resources?.length > 0) {
  //             const image = await fetchImageApi(property.resources[0].value);
  //             return {
  //               ...property,
  //               resources: image ? [image] : [],
  //             };
  //           } else {
  //             return property;
  //           }
  //         })
  //       );
  //       return {
  //         ...item,
  //         properties: extractedProperties,
  //       };
  //     })
  //   );
  //   return projects;
  // }, [fetchImageApi]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await AwsAxios.get(
  //         `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/portfolio/Portfolio--Campaigns-For-Back-End-Import`
  //       );
  //       console.log(response, "response From api all campaigns");
  //       const projects = response.data.data.items;

  //       const updatedProjects = await Promise.all(
  //         projects.map(async (project) => {
  //           const updatedProperties = await Promise.all(
  //             project.properties.map(async (property) => {
  //               if (property.type === "RESOURCES" && property.resources?.length > 0) {
  //                 const image = await fetchImageApi(property.resources[0].value);
  //                 return {
  //                   ...property,
  //                   resources: image ? [image] : [],
  //                 };
  //               }
  //               return property;
  //             })
  //           );

  //           return {
  //             ...project,
  //             properties: updatedProperties,
  //           };
  //         })
  //       );

  //       console.log(updatedProjects, "updatedProjects with images");
  //       setProjectsData(updatedProjects);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching project data:", error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // const extractProjectData = async (projectsData) => {
  //   return projectsData.items.map((item) => {
  //     const extractedProperties = item.properties
  //       .map((property) => {
  //         if (property.type === "SIMPLE") {
  //           return {
  //             id: property.id,
  //             type: property.type,
  //             value: property.value,
  //           };
  //         } else if (property.type === "VALUES") {
  //           return {
  //             id: property.id,
  //             type: property.type,
  //             values: property.values,
  //           };
  //         } else if (property.type === "RESOURCES") {

  //           return {
  //             id: property?.id,
  //             type: property?.type,
  //             resources: await fetchImageApi(property?.resources[0]?.value)
  //           };
  //         }
  //         return null;
  //       })
  //       .filter((property) => property !== null);

  //     return {
  //       id: item.id,
  //       href: item.href,
  //       webUrl: item.webUrl,
  //       properties: extractedProperties,
  //     };
  //   });
  // }

  // const extractProjectData = async (projectsData) => {
  //   const projects = await Promise.all(
  //     projectsData.items.map(async (item) => {
  //       const extractedProperties = await Promise.all(
  //         item.properties.map(async (property) => {
  //           if (property.type === "RESOURCES" && property?.resources?.length > 0) {
  //             const image = await fetchImageApi(property.resources[0].value);
  //             return {
  //               ...property,
  //               resources: image ? [image] : [],
  //             };
  //           } else {
  //             return property;
  //           }
  //         })
  //       );

  //       return {
  //         ...item,
  //         properties: extractedProperties,
  //       };
  //     })
  //   );

  //   return projects;
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await AwsAxios.get(
  //         `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/portfolio/Portfolio--Campaigns-For-Back-End-Import`
  //       );
  //       console.log(response, "response From api all campiagn");
  //       const data = await extractProjectData(response.data.data);
  //       console.log(data, "fetchDataFromMainApi");
  //       setProjectsData(data);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching project data:", error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // const extractedData = projectsData?.items?.map((obj) => ({
  //   title: obj.properties.find((prop) => (prop.id = "title")).value,
  //   status: obj.properties.find((prop) => prop.id === "status").values,
  //   lastChange: obj.properties.find((prop) => prop.id === "lastChange").value,
  //   contributor: obj.properties.find((prop) => prop.id === "contributor").value,
  //   description: obj.properties.find((prop) => prop.id === "description").value,
  //   webUrl: obj.webUrl,
  //   href: obj.href,
  //   id: obj.id,

  //   // status: obj.find(prop => prop.id === "status")?.value || null // Optional chaining to handle if "status" property doesn't exist
  // }));

  console.log({ userProjectData });

  const Partner_Project =userProjectData.length> 0 && userProjectData?.filter(val => val?.CreatedBy?.split("#")[0] === "Partner")
  const SME_Project =userProjectData.length> 0 && userProjectData?.filter(val => val?.CreatedBy?.split("#")[0] === "SME")
  return (
    <>
      <div className="projects-background  mt-8 flex flex-col gap-4">
        <h1 className="text-pureWhite text-[36px] font-bizmo font-semibold">
          Projects
        </h1>
        <p className="text-pureWhite text-center w-[384px] text-sm">
          Embark on Your Learning Journey: Discover, Dive In, and Excel with Our
          Curated Collection of
        </p>
      </div>
      <div className="mt-8 overflow-hidden">
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane key="1" tab="Campaign">
            <ProjectsData
              projectsData={projectsData}
              Imageloading={Imageloading}
              title="Hype Innovation"
            />
          </Tabs.TabPane>
          <Tabs.TabPane key="2" tab="Submitted Ideas">
            <SubmittedIdeas />
          </Tabs.TabPane>
          <Tabs.TabPane key="3" tab="Projects">
          <Tabs  defaultActiveKey="3-1" tabPosition="right">
            <Tabs.TabPane key="3-1" tab="SME Projects"> 
            <UserProjectsData
              projectsData={SME_Project}
              Imageloading={Imageloading}
            />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Parnter Projects" key="3-2">
            <UserProjectsData
              projectsData={Partner_Project}
              Imageloading={Imageloading}
            />
            </Tabs.TabPane>
          </Tabs>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default Projects;
